import React from 'react';
import Dropdown from '@techsoftware/happay-widgets/Dropdown';
import TextInput from '@techsoftware/happay-widgets/TextInput';
import Grid from '@techsoftware/happay-widgets/Grid';
import { isMobile } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import GstTds from '../GstTds';
export default function EditAmountDetails(props) {
  const {
    amount,
    handleChange,
    discount,
    payableAmount,
    drawCardUI,
    isGstApplicable,
    isTdsApplicable,
    gstType,
    tdsType,
    gstPercentage,
    tdsPercentage,
    currencyList,
    currency,
    defaultCurrency,
    error: { amountError, gstError, tdsError, payableAmountError },
    ocrScan,
    shimmer,
    ocrImg,
  } = props;
  const amountCardContent = (
    <Grid
      container
      className={`padding-lr-${isMobile ? '20' : '100'} padding-b-30`}
    >
      <Grid item>
        <Grid
          container
          item
          xs={24}
          sm={24}
          md={24}
          xl={24}
          lg={24}
          justify="space-between"
          alignItems="baseline"
          className="margin-t-30"
        >
          <Dropdown
            id="select-currency-dropdown"
            isRequired
            labelText="Currency"
            dropdownInputHintText="Select currency"
            value={currency || defaultCurrency}
            onChange={(e, i, dt) => handleChange('currency', dt)}
            data={currencyList}
            clearMargin
            customDropdownStyle={{ width: '18%', marginBottom: '10px' }}
            isReset={false}
            shimmer={shimmer}
          />
          <TextInput
            id="invoice-amount"
            floatingLabelText="Gross Amount"
            hintText="Type Gross Amount"
            required
            value={amount}
            type="text"
            isNumberType
            clearMargin
            customInputParentStyle={{ width: '75%' }}
            onChange={(e, val) => handleChange('amount', val)}
            errorText={amountError}
            errorType={amountError && 'error'}
            regex={/^\d*\.?\d{0,2}$/}
            iconImg={ocrScan.amount && amount ? ocrImg : ''}
            iconType
            iconTooltip={ocrScan.amount && amount && 'Auto-fetched via ScanX'}
            shimmer={amount ? false : shimmer}
          />
        </Grid>
        <GstTds
          id="gst"
          isGstApplicable={isGstApplicable}
          gstPercentage={gstPercentage}
          tdsPercentage={tdsPercentage}
          gstType={gstType}
          handleChange={handleChange}
          isGst
          error={gstError}
        />
        <GstTds
          id="tds"
          isGstApplicable={isGstApplicable}
          isTdsApplicable={isTdsApplicable}
          gstPercentage={gstPercentage}
          tdsPercentage={tdsPercentage}
          tdsType={tdsType}
          handleChange={handleChange}
          error={tdsError}
        />
        <TextInput
          floatingLabelText="Discount"
          hintText="Type Discount"
          value={discount}
          isNumberType
          regex={/^\d*\.?\d{0,2}$/}
          onChange={(e, val) => handleChange('discount', val)}
          iconImg={ocrScan.discount && discount ? ocrImg : ''}
          iconType
          iconTooltip={ocrScan.discount && discount && 'Auto-fetched via ScanX'}
          shimmer={shimmer}
        />
        <Grid
          container
          item
          xs={24}
          sm={24}
          md={24}
          xl={24}
          lg={24}
          justify="space-between"
          alignItems="baseline"
          className="margin-t-30"
        >
          <Dropdown
            id="disabled-currency-dropdown"
            isRequired
            disabled
            labelText="Currency"
            dropdownInputHintText="Select currency"
            value={currency || defaultCurrency}
            onChange={(e, i, dt) => handleChange('currency', dt)}
            data={currencyList}
            clearMargin
            customDropdownStyle={{ width: '18%', marginBottom: '10px' }}
          />
          <TextInput
            id="invoice-payable-amount"
            floatingLabelText="Total Payable Amount"
            hintText="Enter Payable Amount"
            value={payableAmount}
            type="text"
            isNumberType
            disabled
            clearMargin
            customInputParentStyle={{ width: '75%' }}
            iconType="info"
            iconTooltip="Gross amount + GST - Discount - TDS"
            iconTooltipClass="total-amt-tooltip"
            iconTooltipPlacement="hw-bottom"
            errorText={payableAmountError}
            errorType={payableAmountError && 'error'}
          />
        </Grid>
      </Grid>
    </Grid>
  );
  return drawCardUI('Amount Details', 3, amountCardContent);
}
